import { render, staticRenderFns } from "./TopUpQuery.vue?vue&type=template&id=3aeab275&scoped=true&"
import script from "./TopUpQuery.vue?vue&type=script&lang=js&"
export * from "./TopUpQuery.vue?vue&type=script&lang=js&"
import style0 from "./TopUpQuery.vue?vue&type=style&index=0&id=3aeab275&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aeab275",
  null
  
)

export default component.exports